import { Pipe, PipeTransform } from '@angular/core';

export interface AutonomyLevel {
  level: number;
  levelName: string;
  levelTitle: string;
  levelDescription: string;
}

export const AUTONOMY_LEVELS: AutonomyLevel[] = [
  {
    level: 1,
    levelName: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_SUGGESTIVE.LEVEL_NAME',
    levelTitle: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_SUGGESTIVE.TITLE',
    levelDescription: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_SUGGESTIVE.DESCRIPTION',
  },
  {
    level: 2,
    levelName: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_ASSISTIVE.LEVEL_NAME',
    levelTitle: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_ASSISTIVE.TITLE',
    levelDescription: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_ASSISTIVE.DESCRIPTION',
  },
  {
    level: 3,
    levelName: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AUTONOMOUS.LEVEL_NAME',
    levelTitle: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AUTONOMOUS.TITLE',
    levelDescription: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AUTONOMOUS.DESCRIPTION',
  },
  {
    level: 4,
    levelName: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AGENTIC.LEVEL_NAME',
    levelTitle: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AGENTIC.TITLE',
    levelDescription: 'AI_ASSISTANT.AUTONOMY_LEVELS.AUTONOMY_AGENTIC.DESCRIPTION',
  },
];

@Pipe({
  name: 'autonomyLevel',
  standalone: false,
})
export class AutonomyLevelPipe implements PipeTransform {
  transform(value: number): AutonomyLevel {
    const index = value - 1;

    if (index < 0) return AUTONOMY_LEVELS[0];
    if (index >= AUTONOMY_LEVELS.length) return AUTONOMY_LEVELS[AUTONOMY_LEVELS.length - 1];

    return AUTONOMY_LEVELS[index];
  }
}
